import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Loadable from 'react-loadable';

// TRANSLATE
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// COMPONENT
import InitialLoading from './components/initialLoading'

// STYLES
import './index.css';

// REGISTER
import registerServiceWorker from './registerServiceWorker';

const LoadableBar = Loadable({
    loader: () => import('./App'),
    loading() {
      return <InitialLoading />
    }
});

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <BrowserRouter>
            <LoadableBar />
        </BrowserRouter>
    </I18nextProvider>
, document.getElementById('root'));
registerServiceWorker(); 































































/*
import React from 'react';
import ReactDOM from 'react-dom';


import {Router, Route, IndexRoute, browserHistory} from 'react-router';


import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'


import App from './components/App';

ReactDOM.render((
    <I18nextProvider i18n={i18n}>
         <Router history={browserHistory}>
            <Route path="/" component={App} />
         </Router>
    </I18nextProvider>
  ), document.getElementById('root'));

import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';
import { useBasename } from 'history'

// TRANSLATE
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'

import './index.css';
import registerServiceWorker from './registerServiceWorker';

// COMPONENTS
import Header from './components/header/header.component';

// PAGES
import Home from './pages/home/home.page';
import Network from './pages/network/network.page';
import Restaurants from './pages/restaurants/restaurants.page'
import Products from './pages/products/products.page';
import Recipes from './pages/recipes/recipes.page';
import Events from './pages/events/events.page';
import NotFound from './pages/404/404.page';
import ServerError from './pages/500/500.page';
import Apply from './pages/apply/apply.page';

// DETAILS
import DetailsRestaurants from './pages/detailsRestaurants/detailsRestaurants.page';
import DetailsProducts from './pages/detailsProducts/detailsProducts.page';
import DetailsReceips from './pages/detailsReceips/detailsReceips.page';
import DetailsEvents from './pages/detailsEvents/detailsEvents.page';

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Router history={browserHistory}>
            <Route path="/" component={Header}>
                <IndexRoute component={Home}/>
                <Route path="/network" component={Network}/>
                <Route path="/network/apply" component={Apply}/>
                <Route path="/restaurants" component={Restaurants}/>
                <Route path="/restaurants/:id" component={DetailsRestaurants}/>
                <Route path="/products" component={Products}/>
                <Route path="/products/:id" component={DetailsProducts}/>  
                <Route path="/recipes" component={Recipes}/>
                <Route path="/recipes/:id" component={DetailsReceips}/>        
                <Route path="/events" component={Events}/>
                <Route path="/events/:id" component={DetailsEvents}/>
            </Route>
            <Route path="/*" component={NotFound}/>
            <Route path="/404" component={NotFound}/>
            <Route path="/500" component={ServerError}/>
        </Router>
    </I18nextProvider>
    ,document.getElementById('root'));


const history = useBasename(() => browserHistory)({ basename: '/' })

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Router history={history}>
            <Route path="/" component={Header}>
                <IndexRoute component={Home} i18n={i18n}/>
                <Route path="/network" component={Network} i18n={i18n}/>
                <Route path="/restaurants" component={Restaurants}/>
                <Route path="/restaurants/:id" component={DetailsRestaurants}/>
                <Route path="/products" component={Products}/>
                <Route path="/products/:id" component={DetailsProducts}/>  
                <Route path="/recipes" component={Recipes}/>
                <Route path="/recipes/:id" component={DetailsReceips}/>        
                <Route path="/events" component={Events}/>
                <Route path="/events/:id" component={DetailsEvents}/>
            </Route>
        </Router>
    </I18nextProvider>
    ,document.getElementById('root'));

//registerServiceWorker();
*/



// WEBPACK FOOTER //
// ./src/index.js